import { render, staticRenderFns } from "./outOfStockIndex.vue?vue&type=template&id=52652ecc&"
import script from "./outOfStockIndex.vue?vue&type=script&lang=js&"
export * from "./outOfStockIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports